export default __webpack_public_path__ + "static/media/sticker-g.e8cd8f01.png";